import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiTrendingDown, FiAlertCircle, FiActivity } from 'react-icons/fi';

const LeadershipReality = () => {
  const points = [
    {
      icon: FiTrendingDown,
      title: "The Accidental Leader",
      desc: "Promoted for performance, but unsupported in people management. It's the most common story in business."
    },
    {
      icon: FiAlertCircle,
      title: "Communication Gap",
      desc: "When 82% of leaders are misunderstood by their teams, execution slows down and frustration goes up."
    },
    {
      icon: FiActivity,
      title: "Silent Burnout",
      desc: "Trying to be everything to everyone leads to exhaustion. You need a sustainable operating system."
    }
  ];

  return (
    <section className="py-32 bg-brand-black text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-purple/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h2 className="text-5xl font-black mb-6 leading-tight">
              Leadership Shouldn't Feel Like <span className="text-brand-purple">Guesswork.</span>
            </h2>
            <p className="text-xl text-gray-400 font-medium leading-relaxed">
              Most leaders are operating on instinct alone. In a complex world, instinct isn't enough. You need a visual, objective language to understand yourself and your people.
            </p>
          </div>
          <div className="hidden lg:block h-px bg-white/10 w-full"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {points.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2 }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 p-10 rounded-3xl hover:bg-white/10 transition-colors"
            >
              <div className="w-12 h-12 bg-brand-purple rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={item.icon} className="text-white w-6 h-6" />
              </div>
              <h3 className="text-2xl font-bold mb-4">{item.title}</h3>
              <p className="text-gray-400 leading-relaxed font-medium">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LeadershipReality;